import React, { FC, useState } from "react";
import { useParams } from "react-router-dom";

import { LottieLoading } from "../../../../components/graphics/LottieLoading";
import { Email } from "../../../../factories/emails/models/emails.models";
import { useAppSelector } from "../../../../redux/redux";
import { useGetWorkEmailQuery } from "../../../../slices/EmailsSlice";
import {
  ContactEmailsNoMessages,
  ContactEmailsThread,
} from "../../../contacts/components/emails/ContactEmailsThread";
import { ComposeEmailModal } from "../../../contacts/modals/ComposeEmailModal";

export const WorkEmails: FC = () => {
  const { user } = useAppSelector((state) => state.appReducer);
  const { workId } = useParams();
  const [isOpenCompose, setIsOpenCompose] = useState(false);
  const [actionEmail, setActionEmail] = useState<Email | null>(null);
  const [isOpenReply, setIsOpenReply] = useState(false);
  const [isOpenReplyAll, setIsOpenReplyAll] = useState(false);
  const [isForward, setIsForward] = useState(false);
  const [expandedEmailIds, setExpandedEmailIds] = useState<
    Record<string, boolean>
  >({});

  const { data: emails, isFetching: isLoading } = useGetWorkEmailQuery({
    userId: user?.id || "",
    workId: workId || "",
  });
  const workEmails = emails?.data || [];

  const handleToggleEmail = (emailId: string) => {
    setExpandedEmailIds((current) => ({
      ...current,
      [emailId]: !current[emailId],
    }));
  };

  const handleToggleAll = () => {
    const allExpanded =
      workEmails.length > 0 &&
      workEmails.every((email) => expandedEmailIds[email.id]);

    setExpandedEmailIds(
      allExpanded
        ? {}
        : Object.fromEntries(workEmails.map((email) => [email.id, true])),
    );
  };

  const handleOpenReply = (email: Email) => {
    setActionEmail(email);
    setIsOpenReply(true);
  };

  const handleOpenReplyAll = (email: Email) => {
    setActionEmail(email);
    setIsOpenReplyAll(true);
  };

  const handleOpenForward = (email: Email) => {
    setActionEmail(email);
    setIsForward(true);
  };

  return (
    <div className={"font-Manrope"}>
      {isLoading ? (
        <LottieLoading />
      ) : workEmails.length === 0 ? (
        <ContactEmailsNoMessages
          description={
            "There are no emails linked to this work yet. Linked messages will appear here automatically."
          }
          onCompose={() => setIsOpenCompose(true)}
        />
      ) : (
        <ContactEmailsThread
          emails={workEmails}
          expandedEmailIds={expandedEmailIds}
          onToggleEmail={handleToggleEmail}
          onToggleAll={handleToggleAll}
          onCompose={() => setIsOpenCompose(true)}
          onReply={handleOpenReply}
          onReplyAll={handleOpenReplyAll}
          onForward={handleOpenForward}
        />
      )}
      {isOpenCompose && (
        <ComposeEmailModal
          isActive={isOpenCompose}
          onClose={() => setIsOpenCompose(false)}
        />
      )}
      {isOpenReply && actionEmail && (
        <ComposeEmailModal
          isActive={isOpenReply}
          onClose={() => setIsOpenReply(false)}
          isReply={true}
          email={actionEmail}
          selectedMail={actionEmail}
        />
      )}
      {isOpenReplyAll && actionEmail && (
        <ComposeEmailModal
          isActive={isOpenReplyAll}
          onClose={() => setIsOpenReplyAll(false)}
          isReplyAll={true}
          email={actionEmail}
          selectedMail={actionEmail}
        />
      )}
      {isForward && actionEmail && (
        <ComposeEmailModal
          isActive={isForward}
          isForward
          email={actionEmail}
          onClose={() => setIsForward(false)}
        />
      )}
    </div>
  );
};
